import React from 'react'
import { Table } from 'antd-v4'
import { Typography } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { observer } from 'mobx-react-lite'
import { RED } from './../../../../constants/Colors'
import { CustomerSearch } from '@getgreenline/customer-search'
interface Props {
  globalCustomers: CustomerSearch.API.GlobalCustomer[]
  isLoading: boolean
  invalidPhoneNumbers: Set<string>
  setSelectedCustomers?: (customers: CustomerSearch.API.GlobalCustomer[]) => void
  setModalCustomer?: (customer: CustomerSearch.API.GlobalCustomer) => void
  isEditable?: boolean
  removeCustomerFromRecipientList: (customerId: string) => void
}

interface CustomerListTableRecord {
  key: string
  name: JSX.Element
  phone: JSX.Element
  remove: JSX.Element
}

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    width: '50%',
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    key: 'phone',
    width: '30%',
  },
  {
    title: 'Remove',
    dataIndex: 'remove',
    key: 'remove',
    width: '20%',
    align: 'center' as const,
  },
]

const _OutreachRecipientsTableV2 = (props: Props) => {
  const {
    globalCustomers,
    isLoading,
    setModalCustomer,
    isEditable,
    removeCustomerFromRecipientList,
    invalidPhoneNumbers,
  } = props

  function mapToTableDataSource(
    globalCustomers: CustomerSearch.API.GlobalCustomer[],
  ): CustomerListTableRecord[] {
    return globalCustomers.map((globalCustomer) => {
      const isNumberInvalid = globalCustomer.phone
        ? invalidPhoneNumbers.has(globalCustomer.phone)
        : true
      const invalidPhoneClass = isNumberInvalid ? 'outreach-invalid-phone' : ''
      return {
        key: globalCustomer.id,
        phone: <div className={invalidPhoneClass}>{globalCustomer.phone}</div>,
        remove: (
          <div>
            <CloseOutlined
              onClick={() => removeCustomerFromRecipientList(globalCustomer.id)}
              style={{ fontSize: '130%', color: RED.red400 }}
            />
          </div>
        ),
        name:
          isEditable && setModalCustomer ? (
            <div
              style={{ color: 'var(--blue)' }}
              className={`cursor-pointer ${invalidPhoneClass}`}
              onClick={() => {
                if (!setModalCustomer) return
                setModalCustomer(globalCustomer)
              }}
            >
              <Typography.Paragraph ellipsis={{ rows: 1 }}>{`
              ${globalCustomer.firstName} ${globalCustomer.lastName}
              `}</Typography.Paragraph>
            </div>
          ) : (
            <Typography.Paragraph className={invalidPhoneClass} ellipsis={{ rows: 1 }}>
              {`
              ${globalCustomer.firstName} ${globalCustomer.lastName}
              `}
            </Typography.Paragraph>
          ),
      }
    })
  }

  return (
    <Table<CustomerListTableRecord>
      id='outreach-recipients-table-v2'
      dataSource={mapToTableDataSource(globalCustomers)}
      rowKey={(customer) => customer.key}
      className='no-background-table'
      rowClassName={() => 'background-white'}
      columns={columns}
      pagination={false}
      scroll={{ y: 600 }}
      loading={isLoading}
    />
  )
}

export const OutreachRecipientsTableV2 = observer(_OutreachRecipientsTableV2)
